const formatPlate = (val: string): string => (val ? `${val.substring(0, 3)}-${val.substring(3, 7)}` : 'não informado');

export default formatPlate;
